/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business バグ評価レイアウト。バグ評価関連ページのOutletラッパー。アクセスガードは
 * 一覧ページ（VIEW_BUG_EVALUATION 権限が必要）にのみ適用し、詳細ページはマイページの
 * 担当案件起因バグ一覧から参照モードで開けるよう認証済み全員に開放する（バックエンド
 * GET /bug-evaluations/:issueKey も requireAuth のみで同じ方針）。
 * @graph-connects none
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';

/** @graph-connects none */
export const Route = createFileRoute('/bug-evaluation')({
  component: BugEvaluationLayout,
});

/** @graph-connects none */
function BugEvaluationLayout() {
  return <Outlet />;
}
